import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@semsis/ui/base.css';
import { initSentry } from '@referee/error-handling';
import './i18n';
import { App } from './App';

initSentry();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
